import { render, staticRenderFns } from "./ReversedCT.UK.3.vue?vue&type=template&id=2a2afbb6&scoped=true"
import script from "./ReversedCT.UK.3.vue?vue&type=script&lang=js"
export * from "./ReversedCT.UK.3.vue?vue&type=script&lang=js"
import style0 from "./ReversedCT.UK.3.vue?vue&type=style&index=0&id=2a2afbb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2afbb6",
  null
  
)

export default component.exports